// The types used by operations, screens and widgets. Generated by `sui generate` from .sui sources; do not edit.

export type AccountType = "asset" | "liability" | "equity" | "revenue" | "expense";
export const AccountTypeMembers: readonly AccountType[] = ["asset", "liability", "equity", "revenue", "expense"];

export interface ChartAccount {
  readonly id: string;
  readonly organizationId: string;
  readonly legalEntityId: string;
  readonly code: string;
  readonly name: string;
  readonly accountType: string;
  readonly parentAccountId?: string;
  readonly active: boolean;
}

export interface CreatedAccount {
  readonly id: string;
  readonly organizationId: string;
  readonly legalEntityId: string;
}

export type BadgeTone = "neutral" | "success" | "warning" | "danger";
